<template>
  <div class="container">
    <div class="d-flex flex-column">
      <div class="d-flex justify-content-start flex-fill">
        <b-nav tabs>
          <b-nav-item :to="{name:'shipedList'}">已排出貨區（11）</b-nav-item>
          <b-nav-item to="">出貨暫存區（2）</b-nav-item>
          <b-nav-item :to="{name:'waitConfirm'}">待核銷（2）</b-nav-item>
          <b-nav-item to="">已完成出貨（15）</b-nav-item>
        </b-nav>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  export default {

  };

</script>

<style lang="scss">
</style>
